var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatwitheliot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9986 11.5C20.9986 16.1944 17.1931 20 12.4986 20C11.4219 20 10.3919 19.7998 9.4438 19.4345C9.27047 19.3678 9.1838 19.3344 9.11488 19.3185C9.04709 19.3029 8.99802 19.2963 8.92851 19.2937C8.85783 19.291 8.78029 19.299 8.62521 19.315L3.50419 19.8444C3.01595 19.8948 2.77183 19.9201 2.62782 19.8322C2.5024 19.7557 2.41697 19.6279 2.39423 19.4828C2.36812 19.3161 2.48477 19.1002 2.71808 18.6684L4.35374 15.6408C4.48844 15.3915 4.5558 15.2668 4.5863 15.1469C4.61643 15.0286 4.62371 14.9432 4.61408 14.8214C4.60432 14.6981 4.55022 14.5376 4.44202 14.2166C4.1545 13.3636 3.99865 12.45 3.99865 11.5C3.99865 6.80558 7.80423 3 12.4986 3C17.1931 3 20.9986 6.80558 20.9986 11.5Z",
    stroke: "#979797",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatwitheliot);
export default __webpack_public_path__ + "static/media/chat with eliot.cc473682c3f40dc9406ff1e606465f06.svg";
export { ForwardRef as ReactComponent };